import React, { Component, Fragment, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { utils } from "../common/utils";
import { getCustomerReferralCode, createCustomerReferralCode } from "../actions/referralActions";
import SocialShare from "../components/SocialShare";
import { useTranslation } from 'react-i18next';


export default function ReferralCode(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector( state => state.user );
  const settings = useSelector( state => state.settings );
  const [isLoaded, setIsLoaded] = useState(false);
  
  const activeReferralProgramSettingId = props.activeReferralProgramSetting ? props.activeReferralProgramSetting.id : null;
  const program = props.activeReferralProgramSetting;
  useEffect(() => {
    if(!user.referralCode) {
        dispatch(getCustomerReferralCode(user.id));
    } 
    
  }, [])

  const onCreateReferralCode = (e) => {
    e.preventDefault();
    dispatch(createCustomerReferralCode(user.id));
  }

  

  const referralProgramIsActive = (
    user.referralCode ? (<div className="card-body">
    <p className="card-text">{`${utils.getWebshopFullUrl(settings)}register/${user.referralCode}_${activeReferralProgramSettingId}`}</p>
    <p className="card-text text-bold">{t('Share Your Referral Link')}</p>
    <p className="card-text">
      <SocialShare 
        url={`${utils.getWebshopFullUrl(settings)}register/${user.referralCode}_${activeReferralProgramSettingId}`}
        shape="circle"
        showTitle={false}
        displayInline={true}
        supplierName={settings.supplierName}
        senderName={user.firstName + ' ' + user.lastName}
        shareTitle={t('Test' + program?.name)}>
      </SocialShare>
    </p>
    </div>) :
    (<div className="card-body">
      <a className="btn btn-outline-info small btn-sm text-sm" onClick={(e) => onCreateReferralCode(e)}>{t("Create Your Code")}</a>
    </div>)
  );

  return (
    <Fragment>
      
      <div className="card bg-secondary text-center mb-3 padding-1x mt-3">

      

              <div className="card-header text-lg text-bold text-black text-uppercase margin-bottom-1x">{t('Referral Program')}</div>
              {activeReferralProgramSettingId && 
              <div className="container-fluid">
              <div className="row">
              <div className="col-lg-6 margin-bottom-1x">
                <div className="card card-min-height">
                  <div className="card-body">
                    <h5 className="card-title">{program.name}</h5>
                    <p className="card-text" style={{ whiteSpace: "pre-line" }}>{`${program.description}`}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 margin-bottom-1x">
                <div className="card text-center card-min-height">
                  <div className="card-body">
                    <h5 className="card-title">{t('Your Unique, Personalized Referral Link')}</h5>
                    <p className="card-text">{referralProgramIsActive}</p>
                  </div>
                </div>
              </div>
            </div>
            </div>}
              {!activeReferralProgramSettingId && props.isProgramLoaded &&
              <div className="alert alert-info alert-dismissible fade show text-center margin-bottom-1x">
              <span className="alert-close" data-dismiss="alert"></span>
              <i className="icon-layers"></i>&nbsp;&nbsp;<strong>{t("Referral Porgrams Are Not Active, Check Back Later!")}.</strong> 
              </div>}
      </div>  
    </Fragment>
    
  )

}

// {`Invite a friend to join our community and you will get ${referrerDiscount} off your next purchase when they ${referrerRewardTrigger} and they'll get ${refereeDiscount} when they ${refereeRewardTrigger}.`}



// const referrerDiscount = program.referrerDiscountCodeAmountType === AmountType.FixedAmount ? 
// `${program.referrerDiscountCodeDiscountValue}` : `${program.referrerDiscountCodeDiscountValue}%`;
// const referrerRewardTrigger = program.referrerRewardTrigger === RewardTrigger.OnRefereePurchase ?
// "register and make their first purchase" : "register";

// const refereeDiscount = program.refereeDiscountCodeAmountType === AmountType.FixedAmount ? 
// `${program.refereeDiscountCodeDiscountValue}` : `${program.refereeDiscountCodeDiscountValue}%`;
// const refereeRewardTrigger = program.refereeRewardTrigger === RewardTrigger.OnRefereePurchase ?
// "register and make their first purchase" : "register";

